<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>Token工具</div>
    </div>
    <hr>
    <div class='global-body'>
      <el-form :model="generateInfo" label-width="80px" size="small">
        <el-form-item>
          <span style="font-size:12px">生成Token</span>
          <el-button type="primary" style="margin-left:30px" @click="generateToken">生成</el-button>
        </el-form-item>
        <el-form-item label="KEY">
          <el-input v-model="generateInfo.keyStr" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="APPID">
          <el-input v-model="generateInfo.appId" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="6位随机数">
          <el-input v-model="generateInfo.randomStr" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-input v-model="generateInfo.expiredTime" style="width:40%"></el-input>
          <el-button type="warning" style="margin-left:30px" @click="getCurrentTimeStr">获取当前时间</el-button>
        </el-form-item>
        <el-form-item label="明文">
          <el-input v-model="generateInfo.tokenContent" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="TOKEN">
          <el-input v-model="generateInfo.token" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <hr><br>
      <el-form :model="analyzeInfo" label-width="80px" size="small">
        <el-form-item>
          <span style="font-size:12px">解析Token</span>
          <el-button type="danger" style="margin-left:30px" @click="analyzeToken">解析</el-button>
        </el-form-item>
        <el-form-item label="KEY">
          <el-input v-model="analyzeInfo.keyStr" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="TOKEN">
          <el-input v-model="analyzeInfo.token" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="明文">
          <el-input v-model="analyzeInfo.tokenContent" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="APPID">
          <el-input v-model="analyzeInfo.appId" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="6位随机数">
          <el-input v-model="analyzeInfo.randomStr" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-input v-model="analyzeInfo.expiredTime" style="width:40%"></el-input>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-switch v-model="analyzeInfo.effective" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </el-form-item>
        <el-form-item label="错误信息">
          <el-input v-model="analyzeInfo.errorInfo" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'SystemTokenIndex',
  data () {
    return {
      // 遮罩
      loading: {main: false},
      // 可见
      visible: {},
      // 条件
      condition:{},
      // 生成
      generateInfo:{keyStr:'QBC2I+mPeVQ=', appId:'SERVER_ID', randomStr:'123456',expiredTime:''},
      // 解析
      analyzeInfo:{keyStr:'QBC2I+mPeVQ='}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
  },
  
  methods: {
    /*
     * 生成Token
     */
    generateToken: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      // 请求后台
      vm.$http.post('rest/sys/systemToken/generateToken', vm.generateInfo).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        vm.generateInfo= response.body;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /*
     * 解析Token
     */
    analyzeToken: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      // 请求后台
      vm.$http.post('rest/sys/systemToken/analyzeToken', vm.analyzeInfo).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        vm.analyzeInfo= response.body;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /*
     * 获取当前时间
     */
    getCurrentTimeStr: function () {
      let vm = this;
      let myDate = new Date();
      let year = myDate.getFullYear();        //获取当前年份(4位)
      let month = myDate.getMonth()+1;       //获取当前月份(0-11,0代表1月)
      let day = myDate.getDate();        //获取当前日(1-31)
      let hour = myDate.getHours();       //获取当前小时数(0-23)
      let min = myDate.getMinutes();     //获取当前分钟数(0-59)
      let second = myDate.getSeconds();     //获取当前秒数(0-59)

      let dateTimeStr = '';
      dateTimeStr = dateTimeStr + year;
      if(month<10){
        dateTimeStr = dateTimeStr + '0' + month;
      } else {
        dateTimeStr = dateTimeStr + month;
      }
      if(day<10){
        dateTimeStr = dateTimeStr + '0' + day;
      } else {
        dateTimeStr = dateTimeStr + day;
      }
      if(hour<10){
        dateTimeStr = dateTimeStr + '0' + hour;
      } else {
        dateTimeStr = dateTimeStr + hour;
      }
      if(min<10){
        dateTimeStr = dateTimeStr + '0' + min;
      } else {
        dateTimeStr = dateTimeStr + min;
      }
      if(second<10){
        dateTimeStr = dateTimeStr + '0' + second;
      } else {
        dateTimeStr = dateTimeStr + second;
      }
      vm.generateInfo.expiredTime = dateTimeStr;
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemtoken/SystemTokenIndex.vue